module.exports = __webpack_public_path__ + "img/cmb_cosmictokens.821085d.png";